import { ca } from '@cian/analytics';

import { getNewbuildingProduct } from '../../utils/analytics';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

export function trackClickPromoBlock(promo: IPromoInfo, newbuildingId: number) {
  const { promoType, promoId, uniquePromoId } = promo;

  ca('eventSite', {
    action: 'click_block',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getNewbuildingProduct({ newbuildingId, extra: { promoId, promoCianMortgage: uniquePromoId } })],
  });
}
